import type { SortFilter } from '../get-data/transform/sort-filter';

export const UPDATE_SORT_FILTER = 'UPDATE_SORT_FILTER';

export const updateSortFilter = (payload: SortFilter) => ({
    type: UPDATE_SORT_FILTER,
    payload,
});

export default (state = [] as SortFilter, action: ReturnType<typeof updateSortFilter>) =>
    action.type === UPDATE_SORT_FILTER ? [...state, ...action.payload] : state;
